import { observable, computed, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import FoldersIcon from 'img/settings/settings-folders@2x.png';

class CompanyFileFolder extends DomainObject {
  name;
  order;

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      order: observable,
      icon: computed,
      key: computed
    });

    this.merge(other);
  }

  get icon() {
    return FoldersIcon;
  }

  get key() {
    return `folder-${this.id}`;
  }
}

export default CompanyFileFolder;
